import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { showIconByServiceId } from "../../../../helper/showIconByServiceId";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import StatusChanger from "../../edit/status-chenger";
import PaymentStatusChanger from "../../edit/status-chenger/PaymentStatusChanger";
import {ability} from "../../../../config/acl/ability";

const Row = ({
               setOrderOption,
               item,
               setData,
               rowsPerPage,
               currentPage,
               isSelected,
               onSelect
             }) => {
  const [open, setOpen] = useState(false);
  const canReviewOrder = ability.can('order', 'review');
  const userData = JSON.parse(localStorage.getItem("user"));
  return (
      <>
        <TableRow
            key={item.request_id}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
          <TableCell padding="checkbox">
            <Checkbox
                color="primary"
                checked={isSelected}
                onChange={onSelect}
            />
          </TableCell>
          <TableCell>
            <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" align="center">
            {item?.request_id}
          </TableCell>
          <TableCell align="center">
            {item?.offerName || (
                <div className="flex justify-center w-full">
                  <IoMdClose style={{ color: "red" }} />
                </div>
            )}
          </TableCell>
          <TableCell align="center">{item?.user_name}</TableCell>
          <TableCell align="center">{item?.reseller || 'Website'}</TableCell>
          <TableCell align="center">{item?.price}</TableCell>
          <TableCell align="center">
            {item?.discount_type != 'none' && (item?.discount_for_auto_pay || item?.discount_type === 'percentage') ?

                (item?.discount * item?.price / 100) +  (item?.discount_for_auto_pay * item?.price / 100):
                item?.discount ?? 0
            }
          </TableCell>
          <TableCell align="center">
            {item?.discount_type != 'none' && (item?.discount_for_auto_pay || item?.discount_type === 'percentage') ?

                item?.price - (item?.discount * item?.price / 100) +  (item?.discount_for_auto_pay * item?.price / 100):
                item?.price -item?.discount ?? 0
            }
          </TableCell>
          <TableCell align="center">
            <a
                className="inline-block w-full max-w-48 truncate"
                href={item?.panel_url}
                target="_blank"
                rel="noopener noreferrer"
            >
              {item?.panel_url}
            </a>
          </TableCell>
          <TableCell align="center">{item?.created_at}</TableCell>
          <TableCell align="center">{item?.created_By}</TableCell>
          <TableCell align="center">
            <span
                className={`badge w-24 text-darkTextColor ${
                    item?.status_payment === "paid"
                        ? "bg-[#28a745]"
                        : item?.status_payment === "pending"
                        ? "bg-[#f7cb73]"
                        : "bg-[#ff6877]"
                }`}
            >
              {item?.status_payment}
            </span>
          </TableCell>
          <TableCell align="center">
            {userData?.role === 'assistance' ?
                <span
                    className={`badge w-24 text-darkTextColor ${
                        item?.status === "processing"
                            ? "bg-[#28a745]"
                            : item?.status === "pending"
                            ? "bg-[#f7cb73]"
                            : item?.status === "complete"
                                ? "bg-[#3f78e0]"
                                : "bg-[#ff6877]"
                    }`}
                >
                      {item?.status}
                    </span> :
                <StatusChanger
                    setOrderOption={setOrderOption}
                    source="offer"
                    data={item}
                    setData={setData}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                />
            }

          </TableCell>
          <TableCell align="center">
            <Link to={`/Orders/${item?.uuid}`} color="inherit" underline="none">
              <FaEye className="text-[#6c757d]" />
            </Link>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={15}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1, width: "100%" }}>
                <Typography variant="h6" gutterBottom component="div">
                  Offer details
                </Typography>
                {item?.RequestOfferDetails?.length > 0 ? (
                    <Table size="large" aria-label="types">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">ID</TableCell>
                          <TableCell align="center">icon</TableCell>
                          <TableCell align="center">service name</TableCell>
                          <TableCell align="center">title</TableCell>
                          <TableCell align="center">description</TableCell>
                          <TableCell align="center">Logo</TableCell>
                          <TableCell align="center">Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {item?.RequestOfferDetails?.map((subItem) => (
                            <TableRow key={subItem?.id}>
                              <TableCell align="center">{subItem?.id}</TableCell>
                              <TableCell align="center">
                                <div
                                    className="icons"
                                    style={{
                                      height: "40px",
                                      display: "flex",
                                      gap: "8px",
                                      justifyContent: "center",
                                      overflow: "hidden",
                                      width: "100%",
                                      paddingInline: "5px",
                                    }}
                                >
                                  <img
                                      src={showIconByServiceId(subItem?.our_service_id)}
                                      alt="icon"
                                      style={{
                                        maxHeight: "37px",
                                        maxWidth: "40px",
                                        objectFit: "contain",
                                      }}
                                  />
                                </div>
                              </TableCell>
                              <TableCell align="center">
                                {subItem?.our_service_name}
                              </TableCell>
                              <TableCell align="center">{subItem?.title}</TableCell>
                              <TableCell align="center">
                                {subItem?.description_offer}
                              </TableCell>
                              <TableCell align="center">Waiting logo</TableCell>
                              <TableCell align="center">
                          <span
                              className={`badge text-darkTextColor ${
                                  subItem?.status === "complete"
                                      ? "bg-[#114787]"
                                      : subItem?.status === "active"
                                      ? "bg-[#28a745]"
                                      : "bg-[#ff6877]"
                              }`}
                          >
                            {subItem?.status}
                          </span>
                              </TableCell>
                            </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                ) : (
                    <Typography>No Details available</Typography>
                )}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
  );
};

export default Row;